import React from 'react';
import './App.css';

class Author extends React.Component{
	render(){
		return(<div class="author">
	Made by <a href="http://k4kirin.github.io">k4kirin</a>
		</div>);
	}
}
  
export default Author